module.exports = __webpack_public_path__ + "3118cbb014abe150fc5319d4a6898d84.png";